import React from "react";

import RightIcon from "@uui/ChevronRight";

import TooltipWrapper from "@rui/TooltipWrapper";

import { Button } from "./styles";

interface NextButtonProps {
  onClick: () => void;
  disabled?: boolean;
  disabledTooltip?: string;
}

const NextButton = ({
  onClick,
  disabled,
  disabledTooltip,
}: NextButtonProps) => {
  return (
    <TooltipWrapper title={disabledTooltip} show={disabled}>
      <Button
        primary
        onClick={onClick}
        endIcon={<RightIcon />}
        disabled={disabled}
      >
        Continue
      </Button>
    </TooltipWrapper>
  );
};

export default NextButton;
